var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Card',{attrs:{"title":"签署文件"}},[_c('div',{staticClass:"file-card"},_vm._l((_vm.templateData.fileList),function(item){return _c('FilesList',{key:item.fileId,attrs:{"name":item.fileName + item.fileFormat,"del-icon":false,"size":item.fileSize,"logo":item.logo}})}),1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }